/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { first } from 'rxjs/operators';

import { ComponentInterface } from '../../../canvas-common/interfaces/component.interface';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import { Component } from '@appCanvasCommon/component-system/Component';
import { EventBinder } from '../interaction-utils';

import { Interaction } from 'src/app/plain-javascript/services/interaction-blocker';

import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';

export class TicketDoubleTap extends Component implements ComponentInterface {
	/**
	 * Boilerplate for dealing with events.
	 */
	private _binder: EventBinder;
	constructor() {
		super();
	}
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 *
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 *
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 * @param {CanvasAngularLand} canvasAngularLand
	 * @param {DataContainer} dataContainer
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, dataContainer: TicketContainer) {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(this.getParent());
		// Add new event binding
		this._binder.add('hammer-doubletap', (event) => {
			const tappedTicket = dataContainer.getData();

			const hasAccess = canvasAngularLand.planAccessCheck.hasAccessToTicketSync(tappedTicket);
			// if (!planState.accessCheck.isReadOnly() && !planState.accessCheck.hasAccessToTicket2(tappedTicket)){return;}

			//dependencies //TODO - break this divide into seperate classes
			if (canvasAngularLand.dependencies.syncMode && canvasAngularLand.dependencies.syncMode.target) {
				// planState.actions.simpleDependencyToggle(tappedTicket);
				dataContainer.cutInLine();
			}
			//selection
			else {
				if (canvasAngularLand.interactionBlocker.check(Interaction.MultiSelect, { hasAccess })) {
					canvasAngularLand.actions.selectTicketToggle(tappedTicket);
					const count = canvasAngularLand.tickets.selectedTicket$.getValue().list.size;
					const planId = canvasAngularLand.route.snapshot.paramMap.get('planId');
					analyticsEventsService.multiselectDoubleTap(count, planId);
					dataContainer.cutInLine();

					canvasAngularLand.actions.unselectCycleTicket(tappedTicket);
					canvasAngularLand.actions.unselectCycleTicket(
						canvasAngularLand.tickets.selectedTicket$.getValue().list
					);

					//clear floating tickets
					canvasAngularLand.legacyActions.clearFloatingTickets();
				}
			}
		});
	}
	/**
	 * Called on destroy. Clean-up your shit here.
	 */
	public override destroy() {
		this._binder.destroy();
		this._binder = null;
		super.destroy();
	}
}
